import axios from 'axios';

export const SUPPORT_DOCUMENTS_BASE = 'portal_support_docs/';
export const SUPPORT_DOCUMENTS_CONSOLE_URL =
  `https://console.cloud.google.com/storage/browser/static.rxcap.com/${SUPPORT_DOCUMENTS_BASE.slice(0, -1)}`;
export const DEFAULT_SUPPORT_DOCUMENTS_FOLDER = 'default';
const bucketUrl = 'https://storage.googleapis.com/static.rxcap.com/';
const listingUrl = 'https://storage.googleapis.com/storage/v1/b/static.rxcap.com/o';

export const getSupportDocumentsPrefix = folder =>
  `${SUPPORT_DOCUMENTS_BASE}${folder || DEFAULT_SUPPORT_DOCUMENTS_FOLDER}/`;

async function listObjects(params, signal) {
  const items = [];
  const prefixes = [];
  let pageToken;
  do {
    // The next page token is only available after the previous request completes.
    // eslint-disable-next-line no-await-in-loop
    const response = await axios.get(listingUrl, {
      params: { ...params, ...(pageToken ? { pageToken } : {}) },
      signal,
    });
    items.push(...(response.data.items || []));
    prefixes.push(...(response.data.prefixes || []));
    pageToken = response.data.nextPageToken;
  } while (pageToken);
  return { items, prefixes };
}

export async function loadSupportDocumentsFolders(signal) {
  const { prefixes } = await listObjects({ prefix: SUPPORT_DOCUMENTS_BASE, delimiter: '/' }, signal);
  return [...new Set(prefixes
    .filter(prefix => prefix.startsWith(SUPPORT_DOCUMENTS_BASE) && prefix.endsWith('/'))
    .map(prefix => prefix.slice(SUPPORT_DOCUMENTS_BASE.length, -1))
    .filter(folder => folder && !folder.includes('/')))]
    .sort((a, b) => a.localeCompare(b));
}

export async function loadSupportDocuments(folder, signal) {
  const { items } = await listObjects({ prefix: getSupportDocumentsPrefix(folder) }, signal);
  return items;
}

export function groupSupportDocuments(files, folder) {
  const prefix = getSupportDocumentsPrefix(folder);
  const groups = new Map();
  files.forEach(file => {
    if (!file.name?.startsWith(prefix) || file.name.endsWith('/') || !(Number(file.size) > 0)) {
      return;
    }
    const relativeName = file.name.slice(prefix.length);
    if (!relativeName) {
      return;
    }
    const section = relativeName.includes('/') ? relativeName.split('/')[0] : '';
    if (!groups.has(section)) {
      groups.set(section, []);
    }
    groups.get(section).push(file);
  });
  return [...groups.entries()]
    .sort(([a], [b]) => (a === '' ? -1 : b === '' ? 1 : a.localeCompare(b)))
    .map(([name, documents]) => ({ name, documents }));
}

export const getSupportDocumentUrl = file =>
  bucketUrl + file.name.split('/').map(part => encodeURIComponent(part)).join('/');
